import React, { useEffect, useState } from 'react';
import { fetchRecordByKey } from "../../services/IndexedDBUtil";
import { DATABASE_NAME, STORE_NAME } from '../../services/constants';
import SalesPersonSelection from './SalesPersonSelection';
import { getSalesPersons } from '../../services/ApiManageWorkflow'
import { displayMessage } from '../../Utils/helper';

export default function Report3({ Product, Location, Workflow }) {

  const [filteredData, setFilteredData] = useState([])
  const [salesPersons, setSalesPersons] = useState([])

  useEffect(() => {
    const init = async () => {
      let indexedDBResponse = await fetchRecordByKey(DATABASE_NAME, STORE_NAME, 'WFForecastResult');
      if (indexedDBResponse?.success) {
        let _data = indexedDBResponse.record?.data
        let skuData = _data.cities.find(cityData => cityData.city === Location)?.data.find(skuData => skuData.sku === Product)?.data;
        setFilteredData(skuData);
        await fetchSalesPersons(Location);
      }
    }

    init();

  }, [])

  function capitalizeFirstLetter(str) {
    if (!str) return ""; // Return an empty string if input is empty or undefined
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  async function fetchSalesPersons(cityname) {
    let _cityName = capitalizeFirstLetter(cityname);
    let result = await getSalesPersons(_cityName);
    setSalesPersons(result || []);

  }

  return (
    <div >
      <div className='report3-table-container'>
      {filteredData && filteredData.length > 0 ? (
        <table className="table dataselectiontable  table-bordered">
          <thead>
            <tr className="bg-blue-900 text-white">
              {filteredData.map((elem, index) => (<th key={index} className="border border-gray-300 p-2 bg-[#0C3C54] text-white">{elem.frequency_year}</th>))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {filteredData.map((elem, index) => (<td key={index} className="border border-gray-200 p-2">{elem.forecast}</td>))}
            </tr>
          </tbody>
        </table>
      ) : (
        <tr>
          <td colSpan="7" className="text-center p-4">
            No data available
          </td>
        </tr>
      )}
      </div>
      <br />
      <SalesPersonSelection salesPersonList={salesPersons} workflow_id={Workflow.workflow_id} approvStatus={Workflow.approval_status} />

    </div>
  )
}
